var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3397 0.00634766C7.69142 0.00634766 0.679474 6.94509 0.679474 15.5031C0.679474 24.0611 7.69142 30.9998 16.3397 30.9998C24.988 30.9998 32 24.0611 32 15.5031C32 6.94509 24.988 0.00634766 16.3397 0.00634766ZM12.7516 20.4324H10.0572V11.8744H12.7516V20.4324ZM11.411 10.7104C10.5501 10.7104 9.84693 10.021 9.84693 9.16913C9.84693 8.31723 10.5435 7.62791 11.411 7.62791C12.2784 7.62791 12.9685 8.31723 12.9685 9.16913C12.9685 10.021 12.2719 10.7104 11.411 10.7104ZM22.826 20.4324H20.1381V16.2705C20.1381 15.2755 20.1184 14.0009 18.7384 14.0009C17.3583 14.0009 17.1283 15.0804 17.1283 16.1989V20.4324H14.4405V11.8744H17.0166V13.0449H17.0495C17.4109 12.3686 18.2849 11.6598 19.5927 11.6598C22.3134 11.6598 22.8194 13.4286 22.8194 15.7372V20.4324H22.826Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c87fa46651b11b05ac41c1b2b0644c08.svg";
export { ForwardRef as ReactComponent };